<template>
  <v-dialog :value="dialogProp.show" persistent max-width="900">
    <v-card class="elevation-12">
      <v-toolbar :dark="$vuetify.theme.dark" color="primary">
        <v-toolbar-title>
          {{ $t('Добавление УП') }}
        </v-toolbar-title>
      </v-toolbar>
      <general-error v-if="!!generalError" />
      <v-card-text class="pt-3">
        <ValidationObserver ref="userForm" v-slot="{ invalid, validated }">
          <v-row>
            <v-col
                cols="12"
                md="6"
                class="text-left">
              <validatable-text-input
                  v-test="{ input: 'login' }"
                  :value="newUser.login"
                  :rules="{ required: true,
                            min: 3,
                            max: 25,
                            regex: /^([a-zA-Z0-9-._@+]+)$/ }"
                  :label="$t('Логин')"
                  prepend-icon="person"
                  @change="mergeFieldsAction({ login: $event })" />
              <validatable-text-input
                  v-test="{ input: 'password' }"
                  :value="newUser.password"
                  vid="password"
                  rules="required|max:100"
                  :label="$t('Пароль')"
                  prepend-icon="lock"
                  type="password"
                  @change="mergeFieldsAction({ password: $event })" />
              <validatable-text-input
                  v-test="{ input: 'passwordConfirmation' }"
                  :value="newUser.passwordConfirmation"
                  rules="required|confirmed:password"
                  :label="$t('Подтверждение пароля')"
                  prepend-icon="lock"
                  type="password"
                  @change="mergeFieldsAction({ passwordConfirmation: $event })" />
              <validatable-text-input
                  v-test="{ input: 'email' }"
                  :value="newUser.email"
                  rules="required|email"
                  label="Email"
                  prepend-icon="alternate_email"
                  type="email"
                  @change="mergeFieldsAction({ email: $event })" />
              <validatable-text-input
                  v-test="{ input: 'contactPerson' }"
                  :value="newUser.contactPerson"
                  rules="required"
                  :label="$t('Контактное лицо')"
                  prepend-icon="person"
                  @input="mergeFieldsAction({ contactPerson: $event })" />
              <validatable-text-input
                  v-test="{ input: 'phone' }"
                  :value="newUser.phone"
                  :rules="{ required: true,
                            regex: /^[+]?[\d\s(\-);,]+$/ }"
                  :label="$t('Контактный телефон')"
                  prepend-icon="settings_phone"
                  :type="'tel'"
                  @input="mergeFieldsAction({ phone: $event })" />
              <!-- <validatable-document-person-identity
                  v-test="{ input: 'documentPersonIdentity' }"
                  :value="newUser.documentPersonIdentity"
                  :rules="{ required: true,
                            regex: /^\d{4}\s{1}\d{6}$/ }"
                  prepend-icon="assignment_ind"
                  @input="mergeFieldsAction({ documentPersonIdentity: $event })" /> -->
              <validatable-checkbox
                  v-test="{ checkbox: 'subscriptions' }"
                  :value="subscriptions"
                  rules="required"
                  :label="$t('Подписка на рассылку')"
                  prepend-icon="mail"
                  @change="changeSubscriptions" />
            </v-col>
            <v-divider
                :vertical="$vuetify.breakpoint.mdAndUp" />
            <v-col
                cols="12"
                md="6">
              <v-row>
                <v-col cols="10">
                  <validatable-text-input
                      :value="file.fileName"
                      rules="required"
                      :label="documentDescription"
                      prepend-icon="attach_file"
                      readonly />
                </v-col>
                <v-col cols="2" class="text-right" align-self="center">
                  <typed-file-upload
                      :document-type="documentType"
                      :document-group="documentGroup"
                      :upload-method="uploadSingleIdentityFile" />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <user-authorization-document-info
                      ref="authorizationDocumentInfo" />
                </v-col>
              </v-row>
              <v-divider v-if="file.fileId" />
              <v-row v-if="file.fileId">
                <v-col cols="12" class="text-center">
                  <btn-icon-tip
                      id="getFile"
                      icon="get_app"
                      :tip="$t('Скачать документ')"
                      @click="getIdentityFile(file.fileId)" />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-alert
              class="text-center"
              :value="invalid && validated"
              type="error">
            {{ $t('Не все поля заполнены.') }}
          </v-alert>
        </ValidationObserver>
      </v-card-text>
      <v-progress-linear :active="isLoading" color="loader" indeterminate />
      <v-card-actions>
        <v-spacer />
        <v-btn
            id="cancelBtn"
            v-test="{ btn: 'save' }"
            color="primary"
            @click.stop="cancel">
          {{ $t('Отмена') }}
        </v-btn>
        <v-btn
            id="saveBtn"
            ref="saveBtn"
            v-test="{ btn: 'save' }"
            color="primary"
            :disabled="isLoading"
            @click.stop="addUser">
          {{ $t('Сохранить') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import Vue from 'vue'
  import TypedFileUpload from '@/components/reused/ui/TypedFileUpload.vue'
  import BtnIconTip from '@/components/reused/ui/BtnIconTip.vue'
  import ValidatableCheckbox from '@/components/reused/ui/ValidatableCheckbox.vue'
  import ValidatableTextInput from '@/components/reused/ui/ValidatableTextInput.vue'
  // import ValidatableDocumentPersonIdentity from '@/components/reused/ui/ValidatableDocumentPersonIdentity.vue'
  import UserAuthorizationDocumentInfo from '@/components/reused/authorizationDocuments/UserAuthorizationDocumentInfo.vue'
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import { IDENTITY_DOCUMENT_GROUPS, DOCUMENT_TYPES, SUBSCRIPTION_TYPES } from '@/constants/business.js'
  import { PARTICIPANT_TYPE_ENUM, DOCUMENT_TYPE_ENUM } from '@/constants/enums.js'
  import { mapActions, mapState } from 'vuex'
  import { USER_MANAGEMENT, IDENTITY_FILES } from '@/constants/store.js'
  import getFileMixin from '@/utils/mixins/scoped/getFileMixin.js'

  export default {
    components: {
      BtnIconTip,
      ValidatableTextInput,
      UserAuthorizationDocumentInfo,
      GeneralError,
      TypedFileUpload,
      ValidatableCheckbox
      // ValidatableDocumentPersonIdentity
    },
    mixins: [
      getFileMixin('isLoading')
    ],
    props: {
      dialogProp: {
        type: Object,
        default: () => {
          return {
            organizationId: null,
            show: false,
            callback: null
          }
        }
      }
    },
    data () {
      return {
        PARTICIPANT_TYPE_ENUM,
        isLoading: false,
        documentType: DOCUMENT_TYPES.USER_AUTHORIZATION_DOCUMENT,
        documentGroup: IDENTITY_DOCUMENT_GROUPS.ORGANIZATION_AGENT_DOCUMENTS
      }
    },
    computed: {
      ...mapState(IDENTITY_FILES.NAMESPACE, {
        file: state => (state[IDENTITY_FILES.STATE.CURRENT_FILE] || {})
      }),
      ...mapState(USER_MANAGEMENT.NAMESPACE, {
        newUser: state => (state[USER_MANAGEMENT.STATE.NEW_USER] || { }),
        userChanged: state => (state[USER_MANAGEMENT.STATE.USER_CHANGED] || false)
      }),
      documentDescription () {
        return this.$t(DOCUMENT_TYPE_ENUM[this.documentType])
      },
      subscriptions () {
        return this.newUser.subscriptionsStatus === SUBSCRIPTION_TYPES.FULL
      }
    },
    watch: {
      'newUser.subscriptionsStatus': {
        immediate: true,
        handler (newValue) {
          if (!newValue) {
            this.changeSubscriptions(true)
          }
        }
      }
    },
    created () {
      this.clearStore()
    },
    beforeDestroy () {
      this.clearStore()
    },
    methods: {
      ...mapActions(IDENTITY_FILES.NAMESPACE, {
        uploadSingleIdentityFileAction: IDENTITY_FILES.ACTIONS.UPLOAD_SINGLE_IDENTITY_FILE,
        clearSingleIdentityFileAction: IDENTITY_FILES.ACTIONS.CLEAR_SINGLE_IDENTITY_FILE
      }),
      ...mapActions(USER_MANAGEMENT.NAMESPACE, {
        mergeFieldsAction: USER_MANAGEMENT.ACTIONS.MERGE_FIELDS,
        createUserAction: USER_MANAGEMENT.ACTIONS.CREATE_USER,
        clearNewUserAction: USER_MANAGEMENT.ACTIONS.CLEAR_NEW_USER
      }),
      clearStore: async function () {
        await Promise.all(
          [
            this.clearNewUserAction(),
            this.clearSingleIdentityFileAction()
          ])
      },
      changeSubscriptions: function (enabled) {
        const subscriptionsStatus = enabled
          ? SUBSCRIPTION_TYPES.FULL
          : SUBSCRIPTION_TYPES.NONE
        this.mergeFieldsAction({ subscriptionsStatus })
      },
      uploadSingleIdentityFile: async function (form, documentType) {
        // try catch не нужен (если ошибка, обработаем в месте вызова метода)
        await this.uploadSingleIdentityFileAction({
          form,
          documentType
        })
      },
      addUser: async function () {
        try {
          const isValidated = await this.$refs.userForm.validate()
          if (!isValidated) {
            throw new Vue.errorsTypes.ValidationError()
          }
          if (this.userChanged) {
            const authorizationDocument = await this.$refs.authorizationDocumentInfo.getData()

            const user = {
              ...this.newUser,
              organizationId: this.dialogProp.organizationId,
              fileId: this.file.fileId,
              ...authorizationDocument
            }
            this.isLoading = true

            await this.createUserAction(user)
            this.isLoading = false
            if (this.dialogProp.callback) {
              this.dialogProp.callback()
            }
          }

          this.cancel()
        } catch (error) {
          this.isLoading = false
          this.throwIfUnknownError(error)
        }
      },
      cancel: function () {
        this.$emit('close')
      }
    }
  }
</script>
